'use strict';

angular.module('ntmApp').factory('FormGenerator', ['ColumnDependencies', 'ListGridHelper', 'ListGridConstants', 'FormService', 'ListGridStatus', 'DataCollection', 'Utils', 'filterFilter', '$filter', 'ProfileConstants', '$routeParams', 'CommonHelper', 'UserInfo',
  function (ColumnDependencies, ListGridHelper, ListGridConstants, FormService, ListGridStatus, DataCollection, Utils, filterFilter, $filter, ProfileConstants, $routeParams, CommonHelper, UserInfo) {

    function FormGenerator() {
        var self = this;
        var model = { showExpression: {} };
        var columnDependencies = new ColumnDependencies();

        self.prepareFormFields = function (fields, sectionId, data, editType) {

            var convertedFields = [];

            var staffPageSectionIdToDisable = ProfileConstants.DisableFieldsInStaffSection.StaffPageSectionId;
            var StaffInfoTabSectionIdToDisable = ProfileConstants.DisableFieldsInStaffSection.StaffInfoTabSectionId;

            var loginType = UserInfo.GetLoginType();

            var isCayuseOneLogin_StaffSection = (loginType === UserInfo.constants.LoginTypes.Cayuse) && ($routeParams.grid === staffPageSectionIdToDisable || sectionId === StaffInfoTabSectionIdToDisable);

            if (fields && fields.length > 0) {
                fields.forEach(function (field) {

                    var fieldAttriuteId = field.attributeId.toString();

                    field.propertyObj = field.properties ? JSON.parse(field.properties) : {};

                    ListGridHelper.convertByColumnType(data, field, model, field.fieldName);

                    if (!field.isHide) {
                        var formField = { templateOptions: {}, expressionProperties: {}, validation: {}, ngModelElAttrs: {} };
                        var fieldValues = field.values || [];
                        var readOnly = field.protect || editType === 1 && field.editProtect;

                        if(isCayuseOneLogin_StaffSection) {
                            readOnly = readOnly || (ProfileConstants.DisableFieldsInStaffSection.SectionAttributeIdsToDisable.indexOf(fieldAttriuteId) !== -1);
                        }

                        formField.key = field.fieldName;
                        formField.templateOptions.label = field.dialogName ? field.dialogName.replaceAll('_', ' ') : field.name.replaceAll('_', ' ');
                        formField.templateOptions.disabled = readOnly;
                        formField.templateOptions.required = field.required;
                        formField.templateOptions.fieldName = field.fieldName;
                        formField.className = field.displayType ? field.displayType.toLowerCase() : '';

                        columnDependencies.init(field.fieldName, field.propertyObj.dependent);

                        switch (field.type) {
                            case ('DROPLIST'):
                                formField.type = "select";
                                formField.templateOptions.options = [];
                                formField.templateOptions.nullDisplay = 'Please Select';
                                fieldValues.forEach(function (item) {
                                    formField.templateOptions.options.push({
                                        name: item,
                                        value: item
                                    });
                                });
                                
                               
                                
                                break;
                            case ('PICKLIST'):

                                if (_us.isEmpty(field.propertyObj)) {
                                    return;
                                }

                                if (field.propertyObj.type === 'STATUS_PICKER') {
                                    formField.type = "customListbox";
                                    formField.templateOptions.options = ListGridHelper.prepareListboxData(field.propertyObj, fieldValues);
                                    formField.templateOptions.nullDisplay = 'Please Select';
                                    formField.templateOptions.callback = function () {
                                        self.form.$dirty = true;
                                    };
                                } else {

                                    formField.type = "selectType";
                                    formField.templateOptions.groupProp = field.propertyObj.groupBy ? 'groupBy' : null;
                                    formField.templateOptions.options = [];
                                    formField.templateOptions.nullDisplay = 'Please Select';
                                    if (columnDependencies.dependentIDs.includes(field.attributeId)) {
                                        formField.expressionProperties['templateOptions.options'] = 'model.options_' + field.fieldName;
                                        formField.expressionProperties['templateOptions.disabled'] = '!model.enabled_' + field.fieldName;
                                    } else {
                                        formField.templateOptions.options = formField.templateOptions.options.concat(preparePicklistOptions(fieldValues, field.propertyObj, field.attributeId));
                                    }

                                    formField.templateOptions.onChange = function (modelValue) {
    
                                        if (!modelValue) {
                                            setKeyPropertyValues(field, {});
                                            return;
                                        }
                                        if (field.values) {
                                            field.values.forEach(function (item) {
                                                if (item[field.propertyObj.display[0]] === modelValue) {
                                                    setKeyPropertyValues(field, item);
                                                }
                                            });
                                        }

                                        if (columnDependencies.hasDependencies(field.propertyObj.dependent)) {
                                            var depColumns = columnDependencies.dependentMap.get(field.fieldName);

                                            depColumns.forEach(function (dependentColumn) {
                                                if (!dependentColumn) {
                                                    return;
                                                }

                                                var infoTabModel = ListGridStatus.grid && ListGridStatus.grid.infoTabModel ? ListGridStatus.grid.infoTabModel : {};
                                                
                                                var requestData = columnDependencies.prepareRequestData(dependentColumn, field, model, infoTabModel);

                                                model['options_' + dependentColumn.fieldName] = [];

                                                if (!requestData) {
                                                    return;
                                                }

                                                FormService.Picklist(requestData).then(function (result) {

                                                    if (result.data && result.data.length > 0) {
                                                        model['enabled_' + dependentColumn.fieldName] = !readOnly ? true : false;
                                                        switch (dependentColumn.type) {
                                                            case 'CHECKBOXLIST':
                                                                model['options_' + dependentColumn.fieldName] = [];

                                                                result.data.forEach(function (item) {
                                                                    var rec = {
                                                                        id: item[dependentColumn.propertyObj.key],
                                                                        value: item[dependentColumn.propertyObj.display[0]]
                                                                    };

                                                                    if (dependentColumn.propertyObj.groupBy) {
                                                                        rec.groupBy = item[dependentColumn.propertyObj.groupBy];
                                                                    }

                                                                    model['options_' + dependentColumn.fieldName].push(rec);
                                                                });

                                                                break;

                                                            case 'PICKLIST':
                                                                model['options_' + dependentColumn.fieldName] = model['options_' + dependentColumn.fieldName].concat(preparePicklistOptions(result.data, dependentColumn.propertyObj, field.attributeId));

                                                                break;

                                                            case 'AUTOCOMPLETE':
                                                                model[dependentColumn.name] = null;
                                                                model['options_' + dependentColumn.attributeId] = dependentColumn.values = result.data;

                                                                break;
                                                        }

                                                        dependentColumn.values = result.data;
                                                    }
                                                });
                                            });
                                        }
                                    };

                                    if (columnDependencies.hasDependencies(field.propertyObj.dependent) && model[field.fieldName]) {
                                        formField.templateOptions.onChange(model[field.fieldName]);
                                    }
                                }
                                
                                break;
                            case ('TEXTAREA'):
                                formField.type = 'textareaType';
                                formField.ngModelElAttrs.class = 'form-control ' + (field.letterCase ? field.letterCase.toLowerCase() : '');
                                if (field.lines && field.lines > 0) {
                                    formField.templateOptions.rows = field.lines;
                                }
                                break;
                            case ('NUMERIC'):
                                if (field.propertyObj.displayAs === ListGridConstants.NumberDisplayTypes.DurationSplit) {
                                    formField.type = 'durationSplit';
                                    formField.templateOptions.durationChanged = function () {
                                        if (self.form) {
                                            self.form.$setDirty();
                                        }
                                    };
                                    formField.templateOptions.hideSeconds = field.propertyObj.type !== 'HMS';
                                } else {
                                    formField.type = 'formattedNumber';
                                }                                
                                break;
                            case ('CHECKBOX'): case ('boolean'):
                                formField.type = 'checkbox';
                                break;
                            case ('DATE'):
                                formField.type = 'datepicker';
                                break;
                            case ('TIME'):
                                formField.type = 'timepicker';
                                formField.className = formField.className + ' timepicker';
                                break;
                            case ('EMAIL'):
                                formField.type = 'input';
                                formField.templateOptions.type = 'email';
                                break;
                            case ('COLOR'):
                                formField.type = 'colorpicker';
                                formField.templateOptions.options = { format: 'hex', inputClass: 'colorpicker', placeholder: 'Select Color', hue: true, alpha: 'true', swatch: true };
                                break;
                            case ('ICON'):
                                formField.type = 'iconpicker';
                                formField.templateOptions.modelIsChangedCallback = function () {
                                    self.form.$setDirty();
                                };
                                formField.templateOptions.modelIsNotChangedCallback = function () {
                                };
                                break;
                            case ('RADIO'):
                                formField.type = 'radio';
                                formField.className = 'radioBtnGroup';
                                formField.templateOptions.labelProp = "label";
                                formField.templateOptions.valueProp = "label";
                                formField.templateOptions.disabled = readOnly;
                                formField.templateOptions.options = angular.isArray(field.propertyObj) ? field.propertyObj.map(function (item) { return { label: item }; }) : [];
                                break;
                            case ('RADIOBOOLEAN'):
                                formField.type = 'radioboolean';
                                break;
                            case ('RICHTEXT'):
                                formField.type = 'tinymce';
                                formField.templateOptions.options = formField.templateOptions.options = {
                                    selector: 'textarea',
                                    height: 150,
                                    menubar: false,
                                    plugins: [
                                        'advlist autolink lists link image charmap print preview anchor',
                                        'searchreplace visualblocks code fullscreen',
                                        'insertdatetime media table contextmenu paste code'
                                    ],
                                    toolbar: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                                    content_css: [
                                        '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
                                        '//www.tinymce.com/css/codepen.min.css'],
                                    readonly: readOnly
                                };

                                break;

                            case ('DATACOLLECTION'):
                                formField.type = 'dataCollection';
                                self.DataCollection = new DataCollection();
                                formField.templateOptions.openDialog = function () {
                                    var row = ListGridHelper.createEmptyRecord();
                                    ListGridHelper.convertToGridData(row, model);
                                    row.dialogModel = model;
                                    row.DataCollection = self.DataCollection;
                                    var modal = Utils.OpenModal('', 'ng1/src/setup/templates/dataCollectionView.html', 'DataCollectionController', row, 'data-collection-dialog');
                                    modal.result.then(function (setDirty) {
                                        if (setDirty) {
                                            self.form.$setDirty();
                                            self.DataCollection.dataHasChanged = false;
                                        }
                                    });
                                };
                                break;

                            case ('CHECKBOXLIST'):
                                if (_us.isEmpty(field.propertyObj)) {
                                    return;
                                }


                                formField.type = 'ui-select-multiple';
                                if (field.required) {
                                    formField.className = field.fieldName + ' required-field';
                                }
                                formField.templateOptions.settings = { buttonDefaultText: 'Please select' };
                                formField.templateOptions.extra = {
                                    smartButtonMaxItems: 4,
                                    scrollableHeight: '200px',
                                    enableSearch: true,
                                    allowSelectionByGroups: field.propertyObj.selectByGroup,
                                    smartButtonTextConverter: function (itemText) {
                                        return itemText;
                                    }
                                };
                                formField.templateOptions.events = {
                                    onItemSelect: function () {
                                        self.form.$setDirty();
                                    },
                                    onItemDeselect: function () {
                                        self.form.$setDirty();
                                    },
                                    onDeselectAll: function () {
                                        self.form.$setDirty();
                                    },
                                };

                                formField.templateOptions.groupBy = field.propertyObj.groupBy ? 'groupBy' : false;

                                model[field.fieldName] = [];
                                var vals = [];
                                if (data[field.fieldName]) {
                                    vals = data[field.fieldName].split(";");
                                }

                                formField.templateOptions.options = [];

                                fieldValues.forEach(function (item) {
                                    if (field.propertyObj.display && field.propertyObj.display.length > 0) {
                                        field.propertyObj.display.forEach(function (prop) {
                                            if (item[prop]) {
                                                var rec = {
                                                    id: item[field.propertyObj.key],
                                                    value: item[prop]
                                                };

                                                if (field.propertyObj.groupBy) {
                                                    rec.groupBy = item[field.propertyObj.groupBy] || 'Others';
                                                }

                                                formField.templateOptions.options.push(rec);
                                            }
                                        });
                                    }

                                    if (vals.indexOf(item[field.propertyObj.display[0]]) !== -1 || vals.indexOf(item[field.propertyObj.key]) !== -1) {
                                        model[field.fieldName].push({
                                            id: item[field.propertyObj.key],
                                            value: item[field.propertyObj.display[0]]
                                        });
                                    }
                                });

                                if (columnDependencies.dependentIDs.includes(field.attributeId)) {
                                    formField.expressionProperties['templateOptions.options'] = 'model.options_' + field.fieldName;
                                    formField.expressionProperties['templateOptions.disabled'] = '!model.enabled_' + field.fieldName;
                                }

                                break;
                            case ('AUTOCOMPLETE'):

                                if (_us.isEmpty(field.propertyObj)) {
                                    return;
                                }

                                formField.type = 'typeahead';
                                formField.expressionProperties['templateOptions.options'] = 'model.options_' + field.attributeId;
                                formField.templateOptions.displayField = field.propertyObj.display[0];

                                model['options_' + field.attributeId] = field.values;

                                formField.templateOptions.getOptions = function (search) {
                                    var data = angular.copy(field.values || field.values);
                                    var results = filterFilter(data, { [field.propertyObj.display[0]]: search });

                                    if (field.propertyObj.groupBy) {
                                        results.map(function (res) {
                                            res.group = res[field.propertyObj.groupBy];
                                            return res;
                                        });

                                        results = _us.groupBy(results, field.propertyObj.groupBy);
                                        results = _us.map(results, function (g) {
                                            g[0].firstInGroup = true;  // the first item in each group
                                            return g;
                                        });
                                        results = _us.flatten(results);
                                        results = $filter('orderBy')(results, 'group');
                                    }

                                    return results;
                                };

                                formField.templateOptions.onSelect = function (record) {
                                    if (field.values) {
                                      field.values.forEach(function (item) {
                                        if ((field.propertyObj.compositeKey && Array.isArray(field.propertyObj.compositeKey) && field.propertyObj.compositeKey.every(keyName => item[keyName] === record[keyName])) ||
                                           (!field.propertyObj.compositeKey && field.propertyObj.key && item[field.propertyObj.key] === record[field.propertyObj.key])) {
                                                if (field.propertyObj.fields && field.propertyObj.fields.length > 0) {
                                                    field.propertyObj.fields.forEach(function (field) {
                                                        var col = ListGridHelper.getColumnByFieldName(field);

                                                        if (col) {
                                                            switch (col.type) {
                                                                case ('DATE'):
                                                                    model[col.fieldName] = item[field] ? new Date(item[field]) : null;
                                                                    break;
                                                                case ('TIME'):
                                                                    model[col.fieldName] = item[field] ? new Date(item[field]) : null;
                                                                    break;
                                                                case ('CHECKBOXLIST'):
                                                                    model[col.fieldName] = item[field] && item[field].substr(item[field].length - 1) === ';' ? item[field].slice(0, -1) : item[field];
                                                                    break;

                                                                default:
                                                                    model[col.fieldName] = item[field];
                                                            }
                                                        }
                                                    });
                                                }
                                            }
                                        });
                                  }
                                  if (columnDependencies.hasDependencies(field.propertyObj.dependent)) {
                                    var depColumns = columnDependencies.dependentMap.get(field.fieldName);

                                    depColumns.forEach(function (dependentColumn) {
                                      if (!dependentColumn) {
                                        return;
                                      }

                                      var infoTabModel = ListGridStatus.grid && ListGridStatus.grid.infoTabModel ? ListGridStatus.grid.infoTabModel : {};
                                      var requestData = columnDependencies.prepareRequestData(dependentColumn, field, model, infoTabModel);
                                      model['options_' + dependentColumn.fieldName] = [];

                                      if (!requestData) {
                                        return;
                                      }

                                      FormService.Picklist(requestData).then(function (result) {
                                        if (result.data && result.data.length > 0) {
                                          model['enabled_' + dependentColumn.fieldName] = !readOnly ? true : false;
                                          switch (dependentColumn.type) {
                                            case 'CHECKBOXLIST':
                                              model['options_' + dependentColumn.fieldName] = [];
                                              result.data.forEach(function (item) {
                                                var rec = {
                                                  id: item[dependentColumn.propertyObj.key],
                                                  value: item[dependentColumn.propertyObj.display[0]]
                                                };

                                                if (dependentColumn.propertyObj.groupBy) {
                                                  rec.groupBy = item[dependentColumn.propertyObj.groupBy];
                                                }

                                                model['options_' + dependentColumn.fieldName].push(rec);
                                              });
                                              break;

                                            case 'PICKLIST':
                                              model['options_' + dependentColumn.fieldName] = model['options_' + dependentColumn.fieldName].concat(preparePicklistOptions(result.data, dependentColumn.propertyObj, field.attributeId));
                                              break;

                                            case 'AUTOCOMPLETE':
                                              model[dependentColumn.name] = null;
                                              model['options_' + dependentColumn.attributeId] = dependentColumn.values = result.data;
                                              break;
                                          }
                                          dependentColumn.values = result.data;
                                        }
                                      });
                                    });
                                  }
                                };

                                if (data.hasOwnProperty(formField.key)) {
                                  formField.templateOptions.onSelect(data);
                                }
                                if (columnDependencies.dependentIDs.includes(field.attributeId)) {
                                    formField.expressionProperties['templateOptions.disabled'] = '!model.enabled_' + field.fieldName;
                                }

                                break;
                            default:
                                formField.type = "inputType";
                                formField.ngModelElAttrs.class = 'form-control ' + (field.letterCase ? field.letterCase.toLowerCase() : '');

                                if (field.required && field.length) {
                                    formField.templateOptions.maxlength = field.length;
                                }
                                break;
                        }

                        if (field.cluetip.content) {
                            formField.templateOptions.cluetip = field.cluetip.content;
                            formField.wrapper = 'toolTipWrapper';
                        }

                        convertedFields.push(formField);
                    }
                });
            }

            return convertedFields;
        };

        self.getModel = function () {
            return model || {};
        };

        self.getOptions = function () {
            var options = {
                formState: {
                    awesomeIsForced: false
                }
            };
            return options;
        };

        // private methods 
        function preparePicklistOptions(values, property) {
            var picklistOptions = [];
            var order = [];

            values.forEach(function (item) {
                var option = {
                    name: item[property.display[0]],
                    //TODO: rework picklist type. 413826 - ROOM_NO for Unplanned Activity
                    //value: property.groupBy && attributeId === 413826 ? item[property.groupBy] + '/' + item[property.display[0]] : item[property.display[0]]
                    value: item[property.display[0]]
                };

                if (property.groupBy) {
                    option.groupBy = item[property.groupBy] || 'Others';
                    var groupByField = property.groupBySortField || 'groupBy';
                    option[property.groupBySortField] = item[property.groupBySortField];
                    order.push(property.groupOrder === 'DESC' ? '-{0}'.format(groupByField) : groupByField);
                }

                if (property.sort && property.sort.length > 0) {
                    property.sort.forEach(function (sortItem) {
                        option[sortItem.field] = item[sortItem.field];
                        order.push(sortItem.order === 'DESC' ? '-{0}'.format(sortItem.field) : sortItem.field);
                    });
                }

                picklistOptions.push(option);
            });

            return $filter('orderBy')(picklistOptions, order);
        }

        function setKeyPropertyValues(column, item) {
            if (column.propertyObj.fields && column.propertyObj.fields.length > 0) {

                if (column.propertyObj.savekey && item[column.propertyObj.key]) {
                  var col = ListGridHelper.getColumnByFieldName(column.propertyObj.savekey);

                  if (col) {
                    var value = item[column.propertyObj.key] || null;
                    model[col.fieldName] = value;
                  }
                }
                
                column.propertyObj.fields.forEach(function (field) {
                    var col = ListGridHelper.getColumnByFieldName(field);

                    if (col) {
                        var value = item[field] || null;

                        switch (col.type) {
                            case ('DATE'):
                                model[col.fieldName] = value ? new Date(value) : null;
                                break;
                            case ('TIME'):
                                model[col.fieldName] = value ? new Date(value) : null;
                                break;
                            case ('CHECKBOXLIST'):
                                model[col.fieldName] = value && value.substr(value.length - 1) === ';' ? value.slice(0, -1) : value;
                                break;

                            default:
                                model[col.fieldName] = value;
                        }
                    }
                });
            }
        }
    }

    return (FormGenerator);
}]);
